import { Box, Stack, useTheme } from "@mui/material";
import { Input } from "components";
import React from "react";
import { BillableToggleComponent } from "./CustomerUserSearch";
import { useFormContext } from "react-hook-form";

export const TemplateNameComponent = () => {
  const theme = useTheme();
  const {
    control,
    formState: { errors },
  } = useFormContext();
  return (
    <Box
      sx={{
        p: "12px 16px",
        width: "100%",
        borderRadius: "8px",
        backgroundColor: "#FFF",
      }}
    >
      <Stack>
        <Input
          control={control}
          fullWidth
          required
          sx={{
            color: theme.palette.lightBg.low,
            // backgroundColor: theme.palette.neutral["005"],
            // py: "6px",
            borderRadius: "4px",
            "& .MuiOutlinedInput-root": {
              ...theme.typography["body-medium"],
              "& > fieldset": {
                border: `1px solid ${theme.palette.neutral["010"]}`,
                paddingLeft: "0px",
                // bgcolor: theme.palette.neutral["005"],
              },
              "::placeholder": {
                color: theme.palette.lightBg.low,
              },
            },
          }}
          inputFieledSx={{
            bgcolor: theme.palette.neutral["005"],
          }}
          name="templateName"
          hideHelperBox
          placeholder="Template Name *"
          error={errors.templateName ? true : false}
          //@ts-ignore
          errorMessage={errors.templateName?.message}
        />
      </Stack>
    </Box>
  );
};
